import React from "react";
import "./PricingSection.css";

const plans = [
  {
    name: "Starter",
    price: "$100/month",
    features: [
      "Feature 1 goes here",
      "Feature 2 goes here",
      "Feature 3 goes here",
    ],
    popular: false,
  },
  {
    name: "Pro",
    price: "$200/month",
    features: [
      "Everything in Starter",
      "Feature 1 goes here",
      "Feature 2 goes here",
      "Feature 3 goes here",
    ],
    popular: true,
  },
  {
    name: "Advanced",
    price: "$300/month",
    features: [
      "Best pricing in the plan",
      "Feature 1 goes here",
      "Feature 2 goes here",
      "Feature 3 goes here",
    ],
    popular: false,
  },
];

const PricingSection = () => {
  return (
    <section className="pricing-section">
      <div className="pricing-heading">
        {/* <span className="arrow">➝</span> */}
        <h2>Pricing – Why to buy / How it helps</h2>
      </div>
      <div className="pricing-cards">
        {plans.map((plan, index) => (
          <div
            className={`pricing-card ${plan.popular ? "popular" : ""}`}
            key={index}
          >
            <h3>{plan.name}</h3>
            <p className="price">{plan.price}</p>
            {plan.popular && <div className="badge">Most Popular</div>}
            <button className="cta">CTA</button>
            <ul className="features">
              {plan.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PricingSection;
